/**
 * Created by Balazs Foldesi on 2017. 12. 07.
 */
export default [
	'$scope',
	'$window',
	function ($scope, $window) {
		// A form oldalon localStoragbe lementett adatok felolvasása a thank you page számára
		$scope.pageID = JSON.parse($window.localStorage.dynaData).pageID;
		$scope.dynaData = JSON.parse($window.localStorage.dynaData);
	}
];
